import React from "react";
import { Box, Typography, Grid, Card, CardContent } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Container from "../../../components/Container";
import { UI_CONFIG_ROUTES } from "../routes";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export const UiConfigGlobalPage = () => {
  const navigate = useNavigate();

  const configOptions = [
    {
      title: "Table Ordering Menu Layout",
      description: "Manage menu layouts for table ordering system",
      route: UI_CONFIG_ROUTES.TABLE_ORDERING_MENU_LAYOUT,
    },
  ];

  const handleNavigate = (route) => {
    navigate(route);
  };

  return (
    <Container
      page={"ui-config"}
      searchVal={""}
      onSearch={() => null}
      searchLabel="UI Configuration"
    >
      <Box sx={styles.headerContainer}>
        <Typography variant="h6" sx={styles.title}>
          UI Configuration
        </Typography>
      </Box>

      <Grid container spacing={3} sx={styles.gridContainer}>
        {configOptions.map((option) => (
          <Grid item xs={12} sm={6} md={4} key={option.route}>
            <Card sx={styles.card} onClick={() => handleNavigate(option.route)}>
              <CardContent sx={styles.cardContent}>
                <Box sx={styles.cardHeader}>
                  <Typography variant="h6" sx={styles.cardTitle}>
                    {option.title}
                  </Typography>
                  <ArrowForwardIcon sx={styles.arrowIcon} />
                </Box>
                <Typography variant="body2" sx={styles.cardDescription}>
                  {option.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default UiConfigGlobalPage;

const styles = {
  headerContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 3,
  },
  title: {
    fontFamily: "GilroyBold",
  },
  gridContainer: {
    marginTop: 2,
  },
  card: {
    cursor: "pointer",
    transition: "all 0.3s ease",
    height: "100%",
    "&:hover": {
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      transform: "translateY(-4px)",
    },
  },
  cardContent: {
    padding: 3,
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 2,
  },
  cardTitle: {
    fontFamily: "GilroyBold",
    fontSize: 18,
  },
  arrowIcon: {
    color: "#666",
    transition: "transform 0.3s ease",
    ".MuiCard-root:hover &": {
      transform: "translateX(4px)",
    },
  },
  cardDescription: {
    fontFamily: "GilroyRegular",
    color: "#666",
    fontSize: 14,
  },
};
